import { z } from 'zod';

import { EquipmentStatusSchema } from '@/features/equipment/-constants';
import { EquipmentItemType } from '@/features/equipment/-query/type';

import { EquipmentTableColumns } from './-table/type';

const equipmentItemTypeSchema = z.enum([
  EquipmentItemType.LOANABLE,
  EquipmentItemType.TRANSFERABLE,
  EquipmentItemType.CONSUMABLE,
]);

export const EquipmentTableFilterSchema = z.object({
  pageIndex: z.coerce.number().min(0).default(0),
  pageSize: z.coerce.number().min(1).max(1000).default(100),

  sortColumn: z.nativeEnum(EquipmentTableColumns).optional(),
  orderDirection: z.enum(['asc', 'desc']).default('asc'),

  status: EquipmentStatusSchema.default('ALL'),

  freeText: z.string().optional(),

  equipmentTypeIdIn: z.array(z.string()).optional(),
  equipmentItemIdIn: z.array(z.string()).optional(),
  itemTypeIn: z.array(equipmentItemTypeSchema).optional(),
  assignedWorkerIdIn: z.array(z.string()).optional(),
  placementPlaceIdIn: z.array(z.string()).optional(),
});
